<template>
  <div v-bind="$attrs">
    <h2 class="mb-4 text-2xl uppercase text-gray-777 font-roboto">
      Notificações pelo Whatsapp
    </h2>

    <p class="text-lg text-gray-777 font-roboto">
      Integre o seu WhatsApp para possibilitar o envio de notificações a promotores diretamente pelo WhatsApp.
    </p>

    <div class="mt-7 w-full">
      <div v-if="status == 'starting'" class="w-[162px] h-[162px] mx-auto">
        <p class="text-base mb-2 text-center">Iniciando</p>
        <div class="mx-auto w-12 h-12 rounded-full border-[5px] border-gray-777 border-r-blue-900 spin"></div>
      </div>

      <div v-else-if="status == 'qrcode'" class="w-[162px] h-[162px] mx-auto">
        <img :src="qrcode" alt="QR Code para conectar whatsapp" />
      </div>

      <div v-else-if="status == 'open'" class="w-full">
        <p class="w-[80px] h-[80px] rounded-full text-4xl text-center mx-auto">
          <img :src="profilePicUrl" class="w-full rounded-full" />
        </p>
        <p class="text-2xl font-bold font-roboto text-green-600 text-center mt-4">
          Whatsapp conectado!
        </p>
        <p class="mt-4 text-lg text-center">Você esta logado com:</p>
        <p class="text-lg font-bold text-center">{{ username }}</p>

        <button
          type="button"
          class="px-4 py-2 bg-green-600 text-white font-bold font-roboto rounded-md mx-auto block mt-8"
          @click="whatsappDisconect"
        >
          Desconectar
        </button>
      </div>

      <div class="w-full" v-else-if="anErrorOccurred">
        <p class="w-[80px] h-[80px] bg-red-600 rounded-full text-4xl text-center leading-[80px] text-white mx-auto">
          <font-awesome-icon icon="fa-xmark" />
        </p>

        <p class="text-2xl font-bold font-roboto text-red-600 text-center mt-4">
          {{ errorMessage }}
        </p>

        <button
          type="button"
          class="px-4 py-2 bg-green-600 text-white font-bold font-roboto rounded-md mx-auto block mt-8"
          @click="getWhatsappSession"
        >
          Tentar novamente
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getWhatsappSessionUuid,
  getWhatsappQrCode,
  disconnectWhatsappSession,
} from "./whatsapp"
import { whatsappConnection } from "./socket"

export default {
  data() {
    return {
      session: "",
      status: "",
      errorMessage: "",
      profilePicUrl: "",
      qrcode: "",
      username: "",
    };
  },

  computed: {
    anErrorOccurred() {
      return ["error", "closed"].includes(this.status)
    },
  },

  methods: {
    async whatsappDisconect() {
      try {
        await disconnectWhatsappSession()
        this.getWhatsappSession()
      } catch (err) {
        this.status = "error"
        this.errorMessage = err.message
      }
    },

    async restartSession(sessionName) {
      const response = await getWhatsappQrCode(sessionName)

      this.status = "qrcode"
      this.qrcode = response.base64
    },

    handlerEvents(event) {
      switch (event.data.state) {
        case 'open':
          this.status = 'open'
          break


        case 'close':
          this.status = 'closed'
          this.errorMessage = 'Sessão desconectada'
          break
      }
    },

    handlerSocketConnect(sessionName) {
      whatsappConnection.openSocketConection(sessionName)
      whatsappConnection.onEvent(this.handlerEvents)
    },

    async getWhatsappSession() {
      try {
        this.status = "starting"

        const response = await getWhatsappSessionUuid()

        this.session = response.id
        this.username = response.name
        this.handlerSocketConnect(this.username)

        if (response.connectionStatus == "close" || response.connectionStatus == "connecting")
          this.restartSession(this.username)

        else {
          this.status = "open"
          this.profilePicUrl = response.profilePicUrl
        }

      } catch (err) {
        this.status = "error"
        this.errorMessage = err.message
      }
    },
  },

  mounted() {
    this.getWhatsappSession()
  },
};
</script>

<style>
.spin {
  animation: spin 1s infinite linear;
}

@keyframes spin {
  100% {
    transform: rotateZ(360deg);
  }
}
</style>
